export enum TimeComparison {
  TODAY,
  YESTERDAY,
  LAST_WEEK,
  LAST_MONTH,
  LAST_YEAR,
  CUSTOM,
}

export namespace TimeComparison {
  let elements = [
    TimeComparison.TODAY,
    TimeComparison.YESTERDAY,
    TimeComparison.LAST_WEEK,
    TimeComparison.LAST_MONTH,
    TimeComparison.LAST_YEAR,
    TimeComparison.CUSTOM,
  ];
  let alias = "com.bcdfx.model.TimeComparison";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
